import "./App.css";
// import { ConfirmPage } from "./components/Calendly/ConfirmPage";
import { MainRoutes } from "./Pages/MainRoutes";


function App() {
  return (
    <div className="App">
      <MainRoutes />
      {/* <ConfirmPage /> */}
    </div>
  );
}

export default App;
